import React from 'react';
import Helmet from 'react-helmet';
import genSEO from '../utils/seo';
import { ogUrl } from '../utils/static';

const SEO = ({
    seo,
    script,
    noscript,
    locale = 'zh-hant',
    hreflangs = [],
}) => {
    const {
        title, subtitle, url, jsonld, canonicalUrl,
    } = genSEO(seo);

    return (
        <Helmet defer={false}>
            <html lang={locale} />
            <title>{title}</title>
            <meta name="description" content={subtitle} />
            {/* OpenGraph tags */}
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={subtitle} />
            <meta property="og:image" content={ogUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="1200" />
            <meta property="og:type" content="website" />
            <meta name="keywords" content="電線,電線電纜,漆包線,耐熱漆包線,銅板,紙板,凡立水,台南,建台" />
            {canonicalUrl
                ? <link rel="canonical" href={canonicalUrl} />
                : null}
            {script ? (
                <script
                    key="script"
                    dangerouslySetInnerHTML={{ __html: script }}
                />
            ) : null}
            {noscript && (
                <noscript
                    key="noscript"
                    dangerouslySetInnerHTML={{ __html: noscript }}
                />
            )}
            {jsonld
                ? (
                    <script type="application/ld+json">
                        {JSON.stringify(jsonld)}
                    </script>
                )
                : null}
            {hreflangs.map((item) => (
                <link
                    key={item.lang}
                    rel="alternate"
                    hrefLang={item.lang}
                    href={item.href}
                />
            ))}
        </Helmet>
    );
};

export default SEO;
